import { useState } from 'react';

export const useDrawerToggle = () => {
  const [isPinnedOpen, setIsPinnedOpen] = useState(true);
  const [isHoveringDrawer, setIsHoveringDrawer] = useState(false);

  const handleHoverChange = (isHovering: boolean) => {
    setIsHoveringDrawer(isHovering);
  };

  const pinDrawer = () => {
    setIsHoveringDrawer(false);
    setIsPinnedOpen(true);
  };

  const closeDrawer = () => {
    setIsHoveringDrawer(false);
    setIsPinnedOpen(false);
  };

  return {
    drawerOpen: isPinnedOpen || isHoveringDrawer,
    isPinnedOpen,
    pinDrawer,
    closeDrawer,
    handleHoverChange,
  };
};
